import Layout from "../include/layout";
import { Button, Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import StatutsService from "./StatutsService";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import Filarial from "../include/filarial";
import CustomAddModal from "../../components/CustomAddModal";
import CustomEditModal from "../../components/CustomEditModal";
import Joi from "joi-browser";

export default function StatutIndex() {
    const activeLink = "STATUTS"

    const token = useSelector(state => state.auth.token)
    const [statuts, setStatuts] = useState([])
    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

    const [isVisible, setIsVisible] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [errors, setErrors] = useState({});

    const [addFormData, setAddFormData] = useState({
        libelleStatut: '',
        descriptionStatut: '',
    });

    //declaration des variables pour le form d'edition
    const [editFormData, setEditFormData] = useState({
        libelleStatut: '',
        descriptionStatut: '',
        id: ''
    });


    //####GESTION DES REGLES DE VALIDATIONS ###########///
    const schemaAddData = {
        libelleStatut: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionStatut: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description")
    };

    //GESTION DES REGLES POUR LES FORMULAIRES D'EDITION
    const schemaEditData = {
        libelleStatut: Joi.string().min(2).max(100).required("").empty('').options({
            language: {
                any: { required: 'le champ est obligatoire' },
                string: { min: "minimum 2 caractères", max: "maximum 100" },
            },
        }).label("Libelle"),

        descriptionStatut: Joi.string().min(0).max(1000).empty('').options({
            language: {
                string: { max: "maximum 1000" },
            },
        }).label("Description"),

        id: Joi.number().min(1).empty('').options({
            language: {
                string: { min: "minimum 1" },
            },
        }).label("Id")
    };

    //####END GESTION DES REGLES DE VALIDATIONS ###########///

    //get liste statuts
    const fetchStatuts = async () => {
        await StatutsService.index(token).then((res) => {
            //console.log(res.data.data)
            setStatuts(res.data.data.statuts)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }


    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                StatutsService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchStatuts()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }


    //Gérer les changements sur les formulaires d'ajout
    const handleChange = (event) => {
        //console.log(name)
        const { name, value } = event.target;

        setAddFormData({ ...addFormData, [name]: value });

        let errorData = { ...errors };
        const errorMessage = validateProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...addFormData };
        customerData[name] = event.target.value;
        setAddFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaAddData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };

    //Une fonction pour vider les champs du formulaire
    const clearForm = () => {
        setAddFormData({
            libelleStatut: "",
            descriptionStatut: "",
        });
    };

    //Gérer les changements sur les formulaires de modification
    const handleEditChange = (event) => {
        const { name, value } = event.target;
        setEditFormData({ ...editFormData, [name]: value });
        //console.log(editFormData)
        let errorData = { ...errors };
        const errorMessage = validateEditProperty(event);
        //En cas d'erreur les afficher
        if (errorMessage) {
            errorData[name] = errorMessage;
        } else {
            //Sinon supprimer l'erreur existant
            delete errorData[name];
        }

        let customerData = { ...editFormData };
        customerData[name] = event.target.value;
        setEditFormData(customerData);
        setErrors(errorData);

    }


    //Vérifie si la règle de validation est validé ou pas
    const validateEditProperty = (event) => {
        const { name, value } = event.target;
        const obj = { [name]: value };
        const subSchema = { [name]: schemaEditData[name] };
        const result = Joi.validate(obj, subSchema);
        const { error } = result;
        return error ? error.details[0].message : null;
    };


    //Enregistrer un statut
    const handleSubmit = async (event) => {
        event.preventDefault()
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(addFormData,
            schemaAddData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {
            //
            await StatutsService.store(addFormData, token).then((response) => {
                //console.log(response.data.data)
                //Fermer le modal
                setIsVisible(false)
                //Vider les champs du formulaire
                clearForm()
                if (response.data.status === 200) {
                    //Actualiser la liste
                    fetchStatuts()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        timer: 3000,
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                setIsVisible(false)
                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
                //affichage des erreurs sur le formulaire
                //setValidationError(error.message)
            });

        }
    }

    ///Content du modal d'ajout de statut
    const addModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleSubmit}>
            <div className="col-md-12 mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Libelle <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-libelleStatut"
                    type="text"
                    value={addFormData.libelleStatut}
                    onChange={handleChange}
                    placeholder="Exemple : ACTIF"
                    required={true}
                    name="libelleStatut"
                    style={{ "textTransform": "uppercase" }}
                />

                {errors.libelleStatut && (
                    <div className="alert alert-danger">
                        {errors.libelleStatut}
                    </div>
                )}
            </div>

            <div className="col-md-12 mb-2">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionMatiere" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionStatut"
                    onChange={handleChange}
                    name="descriptionStatut"
                    rows="3"
                    value={addFormData.descriptionStatut}
                ></textarea>

                {errors.descriptionStatut && (
                    <div className="alert alert-danger">
                        {errors.descriptionStatut}
                    </div>
                )}
            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setIsVisible(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    ///Lancer le modal d'edition
    const lauchEdit = async (id) => {
        await StatutsService.show(id, token).then((response) => {
            const data = response.data.data;
            //console.log(response.data.data)
            setEditFormData({
                libelleStatut: data.libelleStatut,
                descriptionStatut: data.descriptionStatut,
                id: id
            })
            setEditModal(true)

        }).catch((error) => {
            Swal.fire({
                icon: "error",
                text: error.message,
            });
        });
    }


    //update fonction
    const handleUpdate = async (event) => {
        event.preventDefault()
        //console.log("okay")
        //Check si les règles de validations sont respectées avant soumission du formulaire
        const result = Joi.validate(editFormData,
            schemaEditData, { abortEarly: false });
        //console.log(result);
        const { error } = result;
        if (error) {
            const errorData = {};
            for (let item of error.details) {
                const name = item.path[0];
                const message = item.message;
                errorData[name] = message;
            }
            //console.log(errors);
            setErrors(errorData);
            return errorData;
        } else {

            //
            await StatutsService.update(editFormData, token).then((response) => {
                //Fermer le modal
                setEditModal(false)

                if (response.data.status !== 200) {
                    Swal.fire({
                        icon: "error",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });

                } else {
                    fetchStatuts()
                    Swal.fire({
                        icon: "success",
                        text: response.data.message,
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            }).catch((error) => {
                //Fermer le modal
                setEditModal(false)

                Swal.fire({
                    icon: "error",
                    text: error.message,
                });
            });
        }
    };


    ///Content du modal d'edition de statut
    const editModalContent = (
        <Form className="needs-validation" noValidate onSubmit={handleUpdate}>
            <div className="row">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-name"
                >
                    Libelle <i className="text-danger">*</i>
                </Form.Label>
                <Form.Control
                    className="form-control"
                    id="bs-validation-libelleStatut"
                    type="text"
                    value={editFormData.libelleStatut}
                    onChange={handleEditChange}
                    placeholder="Exemple : ACTIF"
                    required={true}
                    name="libelleStatut"
                    style={{ "textTransform": "uppercase" }}
                />

                {errors.libelleStatut && (
                    <div className="alert alert-danger">
                        {errors.libelleStatut}
                    </div>
                )}
            </div>

            <div className="row mb-3">
                <Form.Label
                    className="form-label fw-bold"
                    htmlFor="bs-validation-descriptionStatut" >
                    Description <i className="text-danger"></i>
                </Form.Label>
                <textarea
                    className="form-control"
                    id="bs-validation-descriptionStatut"
                    onChange={handleEditChange}
                    name="descriptionStatut"
                    rows="3"
                    value={editFormData.descriptionStatut}
                ></textarea>

                {errors.descriptionStatut && (
                    <div className="alert alert-danger">
                        {errors.descriptionStatut}
                    </div>
                )}

            </div>
            <Modal.Footer className="mt-4">
                <Button variant="secondary" onClick={() => setEditModal(false)}>
                    Fermer
                </Button>
                <Button variant="primary" type="submit">
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Form>
    );

    useEffect(() => {
        fetchStatuts();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Filarial activeLink={activeLink} />

                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-3">
                    <h5 className="card-header">Liste des statuts &nbsp; &nbsp; &nbsp;  <Button variant="primary" onClick={() => setIsVisible(true)}>
                        <FontAwesomeIcon icon="fa-solid fa-circle-plus" /> Ajouter un statut
                    </Button>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">Libelle</th>
                                    <th className="cell text-white">Description</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statuts.length > 0 && statuts.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{item.libelleStatut}
                                        </td>
                                        <td className="cell"><span className="truncate">{item.descriptionStatut}</span></td>
                                        <td className="cell">
                                            <span>{dayjs(item.updatedAt).format("DD/MM/YYYY H:m:s")}</span>
                                        </td>
                                        <td className="cell">
                                            <Button onClick={() => lauchEdit(item.id)}
                                                className="btn btn-sm" severity="warning" style={{ color: "white" }}
                                                title="Modifier"
                                            >
                                                <i className="fas fa-edit"></i>
                                            </Button> &nbsp; &nbsp;
                                            <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                title="Supprimer">
                                                <i className="fas fa-trash"></i></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/*/ Responsive Datatable */}

                {/* Modal Ajout des statuts*/}
                <CustomAddModal
                    modalTitle="Enregistrement statut"
                    modalContent={addModalContent}
                    visible={isVisible}
                    close={() => setIsVisible(false)}
                />

                {/**End Modal Ajout des statuts*/}

                {/* Modal Edition des statuts*/}
                <CustomEditModal
                    modalTitle="Modification statut"
                    modalContent={editModalContent}
                    visible={editModal}
                    close={() => setEditModal(false)}
                />

                {/**End Modal Edition des statuts*/}
            </div>

        </Layout>
    )
}